/* eslint-disable max-len */
export const SHIPPING_FAQ_DATA = [
  {
    open: false,
    question: 'Where does Popsy ships from?',
    answer: `
                  <p>Popsy ships worldwide. We have several sellers located in Asia, North America, Europe and The Middle East. Typically, we will ship your packages from the nearest seller that has your items in stock. If you are ordering from outside the country, we will cover all customs fees, so you don't have to worry about that.&nbsp;</p>
                  `,
    questionAr: 'من أين تقوم بوبسي بالشحن؟',
    answerAr: `
    <p>تقوم بوبسي بالشحن من جميع أنحاء العالم. لدينا العديد من البائعين الموجودين في آسيا وأمريكا الشمالية وأوروبا والشرق الأوسط. عادةً ما نشحن الطرود الخاصة بك من أقرب بائع لديه منتجات مخزنة. إذا كنت تطلب من خارج البلاد، فسنغطي بوبسي جميع الرسوم الجمركية، لذلك لا داعي للقلق بشأن ذلك.</p>
    
    `,
  },

  {
    open: false,
    question: 'What happens if I don`t accept my delivery?',
    answer: `
                 <p> If you refuse to accept your delivery, a charge of 100% of the order value will apply, as the item has already been shipped. If you change your mind after your order has been dispatched, we kindly ask that you accept the delivery first and then submit a return request through our simple returns process to receive a full refund. This helps us ensure smooth order management and minimize disruptions!</p>
                   `,
    questionAr: 'ماذا سيحدث إذا رفضت استلام الطلب؟',
    answerAr: `
   <p> إذا رفضت قبول تسليم طلبك، سيتم تطبيق رسم بقيمة 100% من قيمة الطلب، حيث تم شحن العنصر بالفعل. إذا غيرت رأيك بعد أن تم إرسال طلبك، نرجو منك قبول التسليم أولاً ثم تقديم طلب إرجاع من خلال عملية الإرجاع البسيطة لدينا للحصول على استرداد كامل. يساعدنا ذلك في ضمان إدارة الطلبات بسلاسة وتقليل الاضطرابات! </p>

    `,
  },

  {
    open: false,
    question: 'Why are you asking for my ID?',
    answer: `
              
                    <p>Depending on the country and region, some customs offices require the recipient to show identification before releasing a package. A national ID number, a photograph of ID, or another document may be required by the carrier or Popsy.</p><ul><li>Please note that the name on the ID shared must match the details on your order.</li><li>The ID must show the face of the owner clearly</li><li>The buyer must be of legal age</li></ul><p></p><p><strong>The following countries, regions, and jurisdictions may require an ID number</strong>: Argentina, Bahrain, Bangladesh, Bermuda, Bolivia, Brazil, Bulgaria, Chile, China, Croatia, Cyprus, Czech Republic, Dominican Republic, Egypt, El Salvador, Estonia, Finland, Greece, Guatemala, India, Indonesia, Israel, Italy, Jamaica, Jordan, Kazakhstan, Kenya, Kuwait, Latvia, Lithuania, Mexico, Nigeria, Norway, Oman, Peru, Portugal, Qatar, Romania, Russian Federation, Saudi Arabia, Slovakia, Slovenia, South Africa, South Korea, Spain, Sweden, Taiwan, Turkey, United Arab Emirates, Uruguay.</p>
                    
                   `,
    questionAr: 'لماذا تسالون عن بطاقة التعريف الخاصة بي؟',
    answerAr: `
    <p>تبعا للبلد والمنطقة التي تحددها لشحن الطلب إليها، تطلب بعض مكاتب الجمارك من المتلقي أن يبين هويته قبل إخراج الطرد. قد يطلب الناقل أو بوبسي رقم الهوية الوطني أو صورة الهوية أو مستند آخر.يرجى ملاحظة أن الاسم الموجود على الهوية المرسلة يجب أن يتطابق مع التفاصيل الموجودة في طلبك.يجب أن تظهر بطاقة الهوية وجه المالك بوضوح يجب أن يكون المشتري أتمّ السن القانوني. قد تحتاج البلدان والمناطق والولايات القضائية التالية إلى رقم هوية: الأرجنتين، البحرين، بنغلاديش، برمودا، بوليفيا، البرازيل، بلغاريا، شيلي، الصين، كرواتيا، قبرص، الجمهورية التشيكية، الجمهورية الدومينيكية، مصر، السلفادور، إستونيا، اليونان، غواتيمالا، الهند، إسرائيل، إيطاليا، جامايكا، كازاخستان، الأردن، كينيا، الكويت، لاتفيا، ليتوانيا، المكسيك، نيجيريا، النرويج، عُمان، البيرو، البرتغال، قطر، رومانيا، الاتحاد الروسي، المملكة العربية السعودية، سلوفاكيا، سلوفينيا، جنوب أفريقيا، كوريا الجنوبية، اسبانيا، السويد، تايوان، تركيا، الإمارات العربية المتحدة، والأوروغواي.</p>

    `,
  },

  {
    open: false,
    question: 'Customs and Import Duties (International)',
    answer: `
                    <p>All fees are handled and paid by Popsy.  Your order total will be 100% guaranteed and there will be no additional charges due upon delivery. </p><p></p><p>A representative from one of our courier services companies may contact you to obtain a copy of your ID in order to complete the customs procedure.  However, they will not ask you for any payments.&nbsp;</p><p></p><p>Please&nbsp;contact us at support@popsy.app if you are asked to pay anything.</p>
                    
                
                   `,
    questionAr: 'الرسوم الجمركية ورسوم الاستيراد (الدولية)',
    answerAr: `

                    <p>يتم تولّي جميع الرسوم ودفعها من قبل Popsy. سيكون إجمالي طلبك مضمونًا بنسبة 100٪ ولن تكون هناك رسوم إضافية مستحقة عند التسليم. </p><p>يمكن لممثل من إحدى شركات خدمات البريد السريع لدينا الاتصال بك للحصول على نسخة من بطاقة هويتك لإكمال الإجراءات الجمركية. ومع ذلك، لن يطلبوا منك أي مدفوعات.</p><p> يرجى الاتصال بنا إذا طُلب منك دفع أي شيء."</p><p></p>
                    
                  
    `,
  },

  {
    open: false,
    question: 'Can I change or modify my order?',
    answer: `
                  <p>For unshipped orders, contact our support team ASAP. Shipped orders can't be modified.</p>

                   `,
    questionAr: 'هل أستطيع إلغاء أو تعديل طلبي؟',
    answerAr: `
    
               <p>للطلبات غير المشحونة، اتصل بفريق الدعم الخاص بنا في أسرع وقت ممكن. لا يمكن تعديل الطلبات المشحونة.</p>
                  
    `,
  },

  {
    open: false,
    question: 'Can I cancel my order?',
    answer: `
                <p>When a cancellation request is made, the order status will be reviewed. If the order has already been dispatched, the customer must pay the shipping fees in order to cancel it; however, if the item has not yet been shipped, the cancellation can be made immediately and without incurring any&nbsp;further&nbsp;costs.</p>
                   `,
    questionAr: 'هل أستطيع إلغاء طلبي؟',
    answerAr: `
    
              <p>عند طلب الإلغاء، سيتم التحقق من حالة الطلب. في حال تم شحن الطلب سيترتب على العميل دفع رسوم الشحن إن اراد الاستمرار بالإلغاء، أما في حال ان الطلب لم يتم شحنه بعد، فسيتم الإلغاء مباشرة ودون دفع&nbsp;أي&nbsp;رسوم&nbsp;إضافية.</p>

    `,
  },

  {
    open: false,
    question: 'When will my order arrive?',
    answer: `
                    <p>You can see the estimated delivery date on the product page, including shipping options.</p><p></p><p>All orders are processed within 5-7 business days (Monday-Friday), and we'll send you an Email &amp; SMS (if provided) with your shipment details and tracking number so you can follow your parcel and know exactly when to expect it.</p><p>&nbsp;</p><p><strong>Global Tracking</strong></p><p><a href="https://www.ups.com/track?loc=en_US" target="_blank">UPS</a></p><p><a href="https://www.fedex.com/en-us/tracking.html" target="_blank">Fedex</a></p><p><a href="https://www.dhl.com/us-en/home/tracking.html" target="_blank">DHL</a></p><p>&nbsp;</p><p><strong>Middle East Tracking</strong></p><p><a href="https://www.aramex.com/us/en/track/shipments" target="_blank">Aramex</a></p><p><a href="https://www.dhl.com/us-en/home/tracking.html" target="_blank">DHL</a></p><p></p><p>&nbsp;</p>
                    
                  
    
    `,
    questionAr: 'متى سيصل طلبي ؟',
    answerAr: `
    
            <p>يمكنك رؤية التاريخ التقديري للتسليم على صفحة المنتج، بما في ذلك خيارات الشحن. تتم معالجة جميع الطلبات في غضون 1-3 أيام عمل (من الاثنين إلى الجمعة)، وسنرسل لك بريدًا إلكترونيًا ورسالة قصيرة (إذا تم توفير رقم الهاتف) مع تفاصيل الشحنة ورقم التتبع الخاص بك حتى تتمكن من متابعة الطرد الخاص بك ومعرفة متى بالضبط يمكنك انتظاره. Global TrackingUPSFedexDHL الشرق الأوسط تعقب أرامكس</p>

    `,
  },

  {
    open: false,
    question: 'What are Popsy’s Shipping Options?',
    answer: `
                
                    <p> Popsy offers free shipping on all items, with delivery taking 5-7 business days. We work with trusted carriers like DHL, Aramex, FedEx, and other local couriers to ensure your order arrives safely and on time! </p>
                    <p>&nbsp;</p>
                    <p><strong>Free Shipping</strong></p><p>5 - 7 days delivery</p><p>&nbsp;</p><p><strong>Premium Shipping</strong></p><p>3 - 5 days delivery. Cost varies depending on delivery location</p><p><em>Please note, premium shipping may not be available for your location, we will give you options during checkout.</em></p>
                      
    
    `,
    questionAr: 'من أين تقوم بوبسي بالشحن؟',
    answerAr: `
    <p>بوبسي تقدم شحنًا مجانيًا على جميع العناصر، مع تسليم يستغرق من 5 إلى 7 أيام عمل. نحن نعمل مع شركات النقل الموثوقة مثل DHL، أرامكس، FedEx، وغيرها من شركات التوصيل المحلية لضمان وصول طلبك بأمان وفي الوقت المحدد!</p>
<p>&nbsp;</p>
<p><strong>الشحن المجاني</strong></p>
<p>توصيل خلال 5 - 7 أيام</p>
<p>&nbsp;</p>
<p><strong>الشحن الممتاز</strong></p>
<p>توصيل خلال 3 - 5 أيام. التكلفة تختلف حسب موقع التوصيل</p>
<p><em>يرجى ملاحظة أنه قد لا يكون الشحن الممتاز متاحًا في منطقتك، وسنقدم لك الخيارات أثناء إتمام الدفع.</em></p>

          
    `,
  },

  {
    open: false,
    question: 'I haven`t received the order confirmation email yet. Can you re-send it?',
    answer: `
                    <p>Re-sending the order confirmation email is not an active function at the moment.<br></p><p>If you haven't received your confirmed order email yet, make sure that:<br> </p><p>- You registered the correct email</p><p><br>- Make sure you check your inbox for the email registered against your order.<br><br>- Check your Junk or Spam folders.<br><br>If you still can’t find it, contact our customer service crew at support@popsy.app.</p>
                    
    
    `,
    questionAr: 'لم أتلق بريدًا إلكترونيًا لتأكيد الطلب بعد. هل يمكنك إعادة تقديمه؟',
    answerAr: `

    <p>إذا لم تتلق بريدًا إلكترونياً بتأكيد الطلب والشراء يرجى العلم ان اعادة ارسال البريد الإلكتروني غير فعالة حتى الان. <br><br>لذا في حال لم تتلقى بريدًا الكترونيًا بتأكيد الشراء، أرجو التأكد مما يلي:<br><br>- قمت بتسجيل البريد الإلكتروني الصحيح. <br>- التأكد من البريد في صندوق الوارد، في حال وصلك البريد على الايميل المسجل لدينا. <br>- التحقق من صندوق الرسائل الغير مرغوب بها. <br><br>اذا تأكدت من كل ما سبق ولم تستطع العثور على رسالة تأكيد الشراء بعد، فيمكنك التواصل مع فريق خدمة العملاء على support@popsy.app</p>

    `,
  },

  {
    open: false,
    question: 'Will I receive a confirmation phone call before delivery happens?',
    answer: `
                 <p>In some instances the carrier may contact you to collect more information to complete the delivery.</p>
    
    `,
    questionAr: 'هل سأتلقى مكالمة هاتفية تأكيدية قبل عملية التسليم؟',
    answerAr: `

    <p>في بعض الحالات، قد يتصل بك الناقل لجمع المزيد من المعلومات لإكمال عملية التسليم.</p>

    `,
  },

  {
    open: false,
    question: 'Why hasn`t my order been shipped yet?',
    answer: `
                    <p>We'll notify you once your order has been shipped by the seller. </p><p>In some instances we might need some extra days to ship your order, dependending on our seller's stock levels. While we try to avoid it as much as possible, this can sometimes lead to delays in sending your order.</p><p>If you're concerned that it won't arrive on time because it hasn't yet been shipped, double-check your address information, the size of the item you're ordering, and your payment information to ensure your order is processed as soon as possible. If necessary, we will upgrade your shipping to ensure that it arrives on time.</p><p></p>
                    
    `,
    questionAr: 'لماذا لم يتم شحن طلبي بعد ؟',
    answerAr: `

   <p>سنقوم بإخطارك بمجرد أن يتم شحن طلبك من قبل البائع.<br><br>في بعض الحالات، قد نحتاج إلى بعض الأيام الإضافية لشحن طلبك، اعتمادًا على مستويات مخزون البائع لدينا. بينما نحاول تجنبه قدر الإمكان، قد يؤدي ذلك أحيانًا إلى تأخير في إرسال طلبك.<br><br>إذا كنت قلقًا من أنه لن يصل في الوقت المحدد لأنه لم يتم شحنه بعد، فتحقق مرة أخرى من معلومات العنوان الخاصة بك، وحجم المنتج الذي تطلبه، ومعلومات الدفع الخاصة بك لضمان معالجة طلبك في أقرب وقت ممكن. إذا لزم الأمر، سنقوم بتجديد الشحن الخاص بك للتأكد من وصوله في الوقت المحدد.</p>

    `,
  },

  {
    open: false,
    question: 'My order is late, what can I do?',
    answer: `
                  <p>We apologize for the incovenience. You can contact us at support@popsy.app with your order details and we will get back to you as fast as possible.</p>

    `,
    questionAr: 'لقد تأخّر طلبي، ماذا يمكنني أن أفعل؟',
    answerAr: `
<p>نعتذر عن هذه المشكلة الغير معروفة. يمكنك الاتصال بنا على support@popsy.app مع تفاصيل طلبك وسنعود إليك في أسرع وقت ممكن.</p>
    `,
  },
];
